import { render, staticRenderFns } from "./ComparisonNutritional.vue?vue&type=template&id=004f6383&scoped=true"
import script from "./ComparisonNutritional.vue?vue&type=script&lang=js"
export * from "./ComparisonNutritional.vue?vue&type=script&lang=js"
import style0 from "./ComparisonNutritional.vue?vue&type=style&index=0&id=004f6383&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f6383",
  null
  
)

export default component.exports